import React, {useEffect, useState} from 'react';
import InfiniteScroll from "react-infinite-scroll-component";
import TableRow from './Table-row';
import {t} from "react-switch-lang";
import uniqid from 'uniqid'
import './table-administration.scss';
import './activeClasses.scss'

// How to use
// 
//  tableHeader = ['', '']
//  tableRows = [ {key: value}, buttons: [] ] - value is shown
//              onClick - action (if row is clicked call function)
//              buttons = [ <DropdownButton type='edit' text='Prikazi podatke' action={() => console.log("Prikazi")}/> ] - array of buttons to show in dropdown list
//                  type: edit, delete, remainder ( for image)
//                  text - to display
//                  action - onCLick event
//  fetchMoreData() - callback function to get more data on scroll
//  editableRow: true/false - show/hide button for row editing
//  hasMore: true/false - stop loading if there is no more data
//  isLoading: true/false - loader while loading
//  activeClass = className
// activeRow - indexing active row
// hasTooltip  - hover text in table header
// additional - added non table elements at the end of table
// smallTable - smaller max-width columns


const TableAdministration = ({
                                 tableHeader,
                                 tableRows,
                                 buttons,
                                 fetchMoreData,
                                 editableRow,
                                 hasMore,
                                 activeClass,
                                 activeRow,
                                 smallTable,
                                 additional,
                                 onRefresh,
                                 hasTooltip,
                                 scrollThreshold=0.2
                             }) => {
    const tableId = uniqid();

    const [buttonsHoverWidth, setButtonsHoverWidth] = useState(0);
    const [hasDropdown, setHasDropdown] = useState(true);

    // const element_width = 100 / tableHeader.length; //single table element (column) width in %
    // const stylesWidth = (smallTable === true ? //single table element (column) style
    //         {
    //             width: `${element_width}%`,
    //             minWidth: "100px"
    //         }
    //         :
    //         {
    //             width: `${element_width}%`,
    //             minWidth: "151px"
    //         }
    // );

    /////////// styles
    const contentColumnPercentWidth = 100 / tableHeader.length;
    const contentColumnStyle = {
        width: `${contentColumnPercentWidth}%`,
        minWidth: `${(smallTable === true ? 100 : 150)}px`
    };
    const dropdownButtonWidth = 30;
    const contentsWrapperStyle={
        width: `calc(100% - ${buttonsHoverWidth}px - ${(hasDropdown ? dropdownButtonWidth : 0)}px`,
        minWidth: `${(smallTable === true ? 100 : 150)* tableHeader.length}px`
    };
    const rowWrapperMinWidth = `${(smallTable === true ? 100 : 150)* tableHeader.length + buttonsHoverWidth + (hasDropdown ? dropdownButtonWidth : 0) + 20 + 20 - 6}px`;

    /////////////

    //get max hover buttons in table
    const getHoverButtonsLength = () => {
        let buttonsHoverLength;
        if (tableRows !== undefined) {
            if (tableRows.length > 0) {
                const buttonsHover = [];
                tableRows.map(row => {
                    if(row.buttonsHover !== undefined){
                        const newArr = [];
                        row.buttonsHover.map(item => {
                            if(item !== undefined && item !== false){
                                newArr.push(item)
                            }
                        })
                        buttonsHover.push(newArr.length)
                    }
                })

                if (buttonsHover.length > 0) {
                    buttonsHoverLength = Math.max(...buttonsHover);
                } else {
                    buttonsHoverLength = 0;
                }
            } else {
                buttonsHoverLength = 0;
            }
        }
        return buttonsHoverLength * 28;
    };

    // check if any row has dropdown
    const findIfHasDropdown = () => {
        let result = false;
        if(tableRows !== undefined){
            tableRows.map(row => {
                if(row.buttons !== undefined){
                    const hasButton = row.buttons.find(button => button !== false && button !== undefined);
                    if(hasButton !== undefined){
                        result = true;
                    }
                }
            })
        }
        return result;
    }

    // get text for header tooltip
    const getHeaderItem = (item) => {
        let text = '';
        if (typeof (item) === 'string') {
            text = item;
        } else {
            if (item.props) {
                text = item.props.children[0]
            } else {
                text = item;
            }
        }
        return text;
    };

    const container_width = (smallTable === true ? tableHeader.length * 100 : tableHeader.length * 150);
    const minRowContainerWidth = {minWidth: `${container_width + dropdownButtonWidth + buttonsHoverWidth + 20 + 20 + 5 }px`};

    const containerStyles = {
        maxHeight: `calc(100% - 40px)`,
        overflowY: "auto",
        overflowX: "unset !important",
        ...minRowContainerWidth
    };

    useEffect(() => {
        setButtonsHoverWidth(getHoverButtonsLength());
        setHasDropdown(findIfHasDropdown());
    }, [tableRows]);

    return (
        <div style={{width: "100%", overflow: "auto"}} className="administration-table-component-container">

                <div className="main-row-style header-element" style={{
                    minWidth: rowWrapperMinWidth,
                    width: "100%"
                }}>
                    <div className="colsTable"
                         style={contentsWrapperStyle}
                    >
                        {tableHeader.map((item, index) => {
                            return <div style={contentColumnStyle} key={index}
                                        className={`position-relative table-header-item-container ${hasTooltip ? "hasTooltip" : ''} text-truncate`}>
                                {item}
                                {hasTooltip &&
                                <span className="table-headers-tooltip">
                                            {getHeaderItem(item)}
                                        </span>
                                }
                            </div>
                        })}
                    </div>
                    <div style={{width: buttonsHoverWidth, minWidth: buttonsHoverWidth}}> </div>
                    <div style={{width: dropdownButtonWidth, minWidth: dropdownButtonWidth}}> </div>
                </div>

            <div className="table-administration-container"
                 id={tableId}
                 style={{
                     maxHeight: `calc(100% - 40px)`,
                     overflowY: "auto",
                     // overflowX: "unset !important",
                     overflowX: "visible !important",
                     minWidth: rowWrapperMinWidth,
                     width: "100%"
                 }}>
                <InfiniteScroll
                    dataLength={tableRows.length}
                    next={fetchMoreData && (() => fetchMoreData())}
                    refreshFunction={onRefresh && (() => onRefresh())}
                    hasMore={hasMore}
                    scrollableTarget={tableId}
                    scrollThreshold={scrollThreshold}
                >
                    {tableRows.length > 0 ?
                        tableRows.map((item, index) => (
                            <TableRow
                                activeRow={activeRow}
                                tableRowData={item}
                                index={index}
                                key={index}
                                buttons={buttons}
                                hide={editableRow}
                                rowWrapperStyle={{
                                    minWidth: rowWrapperMinWidth,
                                    width: "100%"
                                }}
                                contentsWrapperStyle={contentsWrapperStyle}
                                contentColumnStyle={contentColumnStyle}
                                buttonsHoverWidth={buttonsHoverWidth}
                                activeClass={activeClass}
                            />
                        ))
                        :
                        <div
                            className="mx-auto text-center">{t('common.noData')}</div>
                    }
                    {additional}
                </InfiniteScroll>
            </div>
        </div>
    );
};

export default TableAdministration;